export default __webpack_public_path__ + "static/media/Daftar Jenis Aset.5fcb877f.png";